<a (click)="openMap();" style="padding-left: 10px;">
  <img
  [class]="parentClass"
  *ngIf="this.recordProperty.ValueAsObject != ''"
  [src]="'https://dev.virtualearth.net/REST/V1/Imagery/Map/Road/' + this.recordProperty.ValueAsObject + '?key=AtiZ6UY75PxZt_r_Wf-qcDVw_wVXIRml2LKA56spkCWhIWY_LAGzoz6AZqI_EK9X&mapLayer=Basemap,Buildings'" />
</a>
